import type { SVGProps } from "react";

export const QualificationsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
    <path
      d="M9.25 38.125H5.3125C4.59062 38.125 4 37.5344 4 36.8125V5.3125C4 4.59062 4.59062 4 5.3125 4H43.375C44.0969 4 44.6875 4.59062 44.6875 5.3125V36.8125C44.6875 37.5344 44.0969 38.125 43.375 38.125H39.4375"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5312 34.1875H11.875C11.875 32.3763 10.405 30.9062 8.59375 30.9062V11.875C10.405 11.875 11.875 10.405 11.875 8.59375H36.8125C36.8125 10.405 38.2825 11.875 40.0938 11.875V30.25C38.2825 30.25 36.8125 31.72 36.8125 33.5312H36.1562"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4062 13.8438H28.2812"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4688 18.4375H32.2188"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7812 27.7563V27.625C17.7812 26.1747 18.9559 25 20.4062 25H20.5375C21.2331 25 21.9025 24.7244 22.3947 24.2322L22.4866 24.1403C23.5103 23.1166 25.1706 23.1166 26.2009 24.1403L26.2928 24.2322C26.785 24.7244 27.4544 25 28.15 25H28.2812C29.7316 25 30.9062 26.1747 30.9062 27.625V27.7563C30.9062 28.4519 31.1819 29.1213 31.6741 29.6135L31.7659 29.7053C32.7897 30.7291 32.7897 32.3894 31.7659 33.4197L31.6741 33.5116C31.1819 34.0038 30.9062 34.6732 30.9062 35.3688V35.5C30.9062 36.9503 29.7316 38.125 28.2812 38.125H28.15C27.4544 38.125 26.785 38.4007 26.2928 38.8928L26.2009 38.9847C25.1772 40.0085 23.5169 40.0085 22.4866 38.9847L22.3947 38.8928C21.9025 38.4007 21.2331 38.125 20.5375 38.125H20.4062C18.9559 38.125 17.7812 36.9503 17.7812 35.5V35.3688C17.7812 34.6732 17.5056 34.0038 17.0134 33.5116L16.9216 33.4197C15.8978 32.396 15.8978 30.7357 16.9216 29.7053L17.0134 29.6135C17.5056 29.1213 17.7812 28.4519 17.7812 27.7563Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.985 34.7585L35.5 40.0938L31.5625 40.75L29.5937 44.6875L26.1222 39.0503"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7025 34.7585L13.1875 40.0938L17.125 40.75L19.0937 44.6875L22.4472 38.9453"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.3438 34.8438C26.1559 34.8438 27.625 33.3747 27.625 31.5625C27.625 29.7503 26.1559 28.2813 24.3438 28.2813C22.5316 28.2813 21.0625 29.7503 21.0625 31.5625C21.0625 33.3747 22.5316 34.8438 24.3438 34.8438Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
